//  商户列表
export const agent = {
  tableList: '/account-admin-web/agent/selectAgentPage', // 表格代理列表
  detail: '/account-admin-web/agent/selectAgentById', // 代理详情
  account: '/account-admin-web/agentIncomeRecord/selectSettlementInfoByAgentId', // 代理详情
  add: '/account-admin-web/agent/addAgent', // 代理添加
  update: '/account-admin-web/agent/updateAgent', // 代理编辑
  check: '/account-admin-web/agent/checkAgentById', // 代理状态查询
  selectList: '/account-admin-web/agent/selectAgentByList', // 所有代理选项
  merchantList: '/account-admin-web/agentIncomeRecord/selectMerchantListByAgentId', // 代理下的商户
  allAgentList: '/account-admin-web/agent/selectAllAgent ', // 所有代理

  income: '/account-admin-web/agentIncomeRecord/selectAgentIncomeRecordByPage', // 表格收益列表
  addIncome: '/account-admin-web/agentIncomeRecord/batchCreateAgentIncomeRecord', // 新增代理收益
  batchAddIncome: '/account-admin-web/agentIncomeRecord/batchCreateAgentIncomeRecord', // 新增代理收益
  updateIncome: '/account-admin-web/agentIncomeRecord/updateAgentIncomeRecord', // 更新代理收益
  delIncome: '/account-admin-web/agentIncomeRecord/deleteAgentIncomeRecordById', // 撤销代理收益
  nettingIncome: '/account-admin-web/agentIncomeRecord/offsetBalanceIncomeRecord', // 撤销代理收益
  statistics: '/account-admin-web/agentIncomeRecord/selectIncomeStatistics', // 统计代理收益

  checkCard: '/account-admin-web/agent/validateAndCacheCardInfo', // 校验银行卡
  getBusinessLicense: '/account-admin-web/agent/readBusinessLicense', // 读取营业执照
  getIDCard: '/account-admin-web/agent/readIDCard', // 读取证件信息

  settlement: '/account-admin-web/agentSettlementRecord/selectAgentSettlementRecordByPage', // 结算记录列表
  addSettlement: '/account-admin-web/agentSettlementRecord/addAgentSettlementRecord', // 添加记录
  settlementDetail: '/account-admin-web/agentSettlementRecord/selectSettlementRecordByNo', // 查看结算记录
  review: '/account-admin-web/agentSettlementRecord/auditAgentSettlementRecord' // 审核结算
}

export const report = {
  agent: '/account-admin-web/agentIncomeRecord/selectAgentStatisticalPage'
}



// WEBPACK FOOTER //
// ./src/request/api.js